import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { cn } from "~/utils";
import { parseName } from "~/utils/parsers";
import Unit from "./Unit";

const Module = ({
  hideTagWhenOpen,
  module,
  onModuleSelect,
  onUnitSelect,
  open,
}) => {
  const name = module.name ?? "";
  const units = module.units ?? [];
  const tag = module.tag ?? "";

  return (
    <div className="select-none border-b border-slate-100">
      <div
        className="group flex cursor-pointer items-center justify-between gap-4 py-2"
        onClick={onModuleSelect}
      >
        <div className="flex items-center gap-2">
          <div
            className={cn(
              "flex w-6 flex-none justify-center transition-transform ",
              open
                ? "rotate-180 text-gray-500"
                : "text-gray-400 group-hover:text-gray-500",
            )}
          >
            <ExpandMoreIcon fontSize="small" />
          </div>
          <span
            className={cn(
              "font-semibold",
              open
                ? "text-gray-600"
                : "text-gray-500 group-hover:text-gray-600",
            )}
          >
            {parseName(name)}
          </span>
        </div>
        {((hideTagWhenOpen && !open) || !hideTagWhenOpen) && tag && (
          <span className="flex-none pr-1.5 text-xs text-gray-400 transition group-hover:text-gray-500">
            {tag}
          </span>
        )}
      </div>
      {open && (
        <div className="mb-2 ml-6 flex flex-col">
          {units.map((unit) => (
            <Unit key={unit.cuid} unit={unit} onSelect={onUnitSelect} />
          ))}
          {units.length === 0 && (
            <div className="p-2 text-sm text-gray-400">
              This module has no units
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Module;
